import { faker } from '@faker-js/faker';
import { HttpResponse, http } from 'msw';

import constants from '../constants';
import factory from '../redux/api/factory';
import { PutContextRequestPayload } from '../redux/api/types';

const customers = factory.buildList(faker.number.int({ max: 10, min: 1 }));

const handlers = [
  http.get(constants.endpoints.get.hierarchySummary, () => {
    return HttpResponse.json(customers);
  }),
  http.get(constants.endpoints.get.context, () => {
    return HttpResponse.json({
      customer_group_uuid: customers[0].children[0].uuid,
      customer_uuid: customers[0].uuid,
      enforce: 'customer_group',
      partner_uuid: faker.string.uuid(),
    });
  }),
  http.put(constants.endpoints.put.context, async ({ request }) => {
    const body = (await request.json()) as PutContextRequestPayload;

    return HttpResponse.json({
      customer_group_uuid: body.customer_group_uuid,
      customer_uuid: body.customer_uuid,
      enforce: 'customer_group',
      partner_uuid: faker.string.uuid(),
    });
  }),
];

export default handlers;
